import { render, staticRenderFns } from "./Labels.html?vue&type=template&id=a99a0736&scoped=true&external"
import script from "./Labels.js?vue&type=script&lang=js&external"
export * from "./Labels.js?vue&type=script&lang=js&external"
import style0 from "./Labels.scss?vue&type=style&index=0&id=a99a0736&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99a0736",
  null
  
)

export default component.exports